import NormalGameManager from "../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default abstract class backpackOpenBase extends cc.Component {

    onBackPackOpenPrefab(...arg){
        NormalGameManager._instance.backpackManager.outOneGood(arg[0].backId);
    }
    
}
